(function($){
    var initializeBlock = function( $block ) {
        $block.find('.slides').slick({
            dots:false,
            arrows: true,
            draggable: true,
            infinite: true,
            autoplay: false,
            pauseOnHover: false,
            autoplaySpeed: 5000,
            waitForAnimate: false
        });     
    }

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.slider').each(function(){
            initializeBlock( $(this) );
        });
    });
})(jQuery);